import { render, staticRenderFns } from "./CreateChannelComponent.vue?vue&type=template&id=f0aa0154&lang=pug"
import script from "./CreateChannelComponent.vue?vue&type=script&lang=js"
export * from "./CreateChannelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0aa0154')) {
      api.createRecord('f0aa0154', component.options)
    } else {
      api.reload('f0aa0154', component.options)
    }
    module.hot.accept("./CreateChannelComponent.vue?vue&type=template&id=f0aa0154&lang=pug", function () {
      api.rerender('f0aa0154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/channels/CreateChannelComponent.vue"
export default component.exports